import { createSelector } from 'reselect';
import { getDocument } from './index';

export const getIsOpenRentIncreaseForm = createSelector([getDocument], document => document.isOpenRentIncreaseForm);
